
/*
 ----------------------------- ドメイン ----------------------------------
 */

 var domein = document.domain;

 /*
	----------------------------- ユーザーエージェント ----------------------------------
	*/
 
 ua = window.navigator.userAgent.toLowerCase();
 ver = window.navigator.appVersion.toLowerCase();
 agent = navigator.userAgent.toLowerCase();
 
 var _ua = (function (u) {
		 return {
				 Tablet: u.indexOf("ipad") != -1
								 || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
								 || u.indexOf("kindle") != -1
								 || u.indexOf("silk") != -1
								 || u.indexOf("playbook") != -1,
				 Mobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
								 || u.indexOf("iphone") != -1
								 || u.indexOf("iPhone") != -1
								 || u.indexOf("ipod") != -1
								 || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
								 || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
								 || u.indexOf("blackberry") != -1
		 }
 })(window.navigator.userAgent.toLowerCase());
 
 // ブラウザ判別
 var browser;
 
 if(agent.indexOf("msie") > -1){
	 browser = 'ie';
	 $(function() {
		 $.fn.imageBg = function () {
			 var $this = this;
			 var imgSrc = $this.find('img').attr('src');
			 $this.find('img').hide();
			 $this.css({
				 backgroundImage: 'url("' + imgSrc + '")'
			 });
		 }
		 $('.js-img-bg').each(function () {
			 $(this).imageBg();
		 });
	 });
 }else if(agent.indexOf("trident/7") > -1){
	 browser = 'ie';
	 $(function() {
		 $.fn.imageBg = function () {
			 var $this = this;
			 var imgSrc = $this.find('img').attr('src');
			 $this.find('img').hide();
			 $this.css({
				 backgroundImage: 'url("' + imgSrc + '")'
			 });
		 }
		 $('.js-img-bg').each(function () {
			 $(this).imageBg();
		 });
	 });
 }else if(agent.indexOf("edge") > -1){
	 browser = 'edge';
 }else if (agent.indexOf("chrome") > -1){
	 browser = 'chrome';
 }else if (agent.indexOf("safari") > -1){
	 browser = 'safari';
 }else if (agent.indexOf("opera") > -1){
	 browser = 'opera';
 }else if (agent.indexOf("firefox") > -1){
	 browser = 'firefox';
 }
 
 $(function(){
	 $('html').addClass(browser);
 });
 
 var ua = navigator.userAgent.toLowerCase();
 var isMobile = /iphone/.test(ua)||/android(.+)?mobile/.test(ua);
 
 if (!isMobile) {
		 $('a[href^="tel:"]').on('click', function(e) {
				 e.preventDefault();
		 });
 }
 
 /*
	----------------------------- transform 2D,transform 3D の数値 ----------------------------------
	*/
 
 function transform2d_value(t_obj, number) {
		 var transform = t_obj.css('transform')
		 var values = transform.split('(')[1];
		 if (values !== undefined) {
				 values = values.split(')')[0];
				 values = values.split(', ');
				 var matrix = {
						 'scaleX': values[0],
						 'rotate-Plus': values[1],
						 'rotate-Minus': values[2],
						 'scaleY': values[3],
						 'translateX': values[4],
						 'translateY': values[5]
				 };
				 var prop = parseInt(matrix['' + number + '']);
		 } else {
				 var prop = 0;
		 }
 
		 return prop;
 
 }
 
 function transform3d_value(t_obj, number) {
		 var transform = t_obj.css('transform')
		 var values = transform.split('(')[1];
		 if (values !== undefined) {
				 values = values.split(')')[0];
				 values = values.split(', ');
				 var matrix = {
						 'scaleX': values[0],
						 'rotateZ-Plus': values[1],
						 'rotateY-Plus': values[2],
						 'perspective1': values[3],
						 'rotateZ-Minus': values[4],
						 'scaleY': values[5],
						 'rotateX-Plus': values[6],
						 'perspective2': values[7],
						 'rotateY-Minus': values[8],
						 'rotateX-Minus': values[9],
						 'scaleZ': values[10],
						 'perspective3': values[11],
						 'translateX': values[12],
						 'translateY': values[13],
						 'translateZ': values[14],
						 'perspective4': values[15]
				 };
				 var prop = parseInt(matrix['' + number + '']);
		 } else {
				 var prop = 0;
		 }
		 return prop;
 }
 
 // ------------------- クエリを取得 -------------------
 
 function GetQueryString()
 {
		 var result = {};
		 if (1 < window.location.search.length)
		 {
				 // 最初の1文字 (?記号) を除いた文字列を取得する
				 var query = window.location.search.substring(1);
 
				 // クエリの区切り記号 (&) で文字列を配列に分割する
				 var parameters = query.split('&');
 
				 for (var i = 0; i < parameters.length; i++)
				 {
						 // パラメータ名とパラメータ値に分割する
						 var element = parameters[ i ].split('=');
 
						 var paramName = decodeURIComponent(element[ 0 ]);
						 var paramValue = decodeURIComponent(element[ 1 ]);
 
						 // パラメータ名をキーとして連想配列に追加する
						 result[ paramName ] = paramValue;
				 }
		 }
		 return result;
 }
 
 // ファーストビュー
 $(window).on('load resize', function() {
		 //画面高さ取得
		 var h = $(window).height();
				 h2 = $('#header').height();
				 w = $(window).width();
				 s = $('#top_visual').height();
		 if(w <= 700) {
				 $('.imgcover').css('height', s + 'px');
		 }else{
				 $('.imgcover').css('height', (h - h2) + 'px');
		 }
	 });
 
 //スクロールされたらフェードイン
 $(function () {
		 $(window).on('load scroll', function () {
			 $('.fade_in').each(function () {
				 var elemPos = $(this).offset().top;
				 var scroll = $(window).scrollTop();
				 var windowHeight = $(window).height();
				 if (scroll > elemPos - windowHeight + windowHeight / 8) {
					 $(this).addClass('scrollin');
				 } else {
					 $(this).removeClass('scrollin');
				 }
			 });
		 });
	 });
 
 
 // 固定ヘッダー分調整
 $(window).on('load resize', function() {
		 var h = $('#header').height();
		 $('body').css('margin-top', h + 'px');
	 });
 $(window).on('load',function(){
		 var h = $('#header').height();
	 $(function() {
			 let url = location.href;
			 if(url.indexOf("#") != -1){
					 let id = url.split("#");
					 let $target = $('#' + id[id.length - 1]);
					 if($target.length){
							 let position = ($target.offset().top) - h;
							 $("html, body").animate({scrollTop:position}, 1);
					 }
			 }
	 });
 })
 
	 function all_clear(){
		 $('*').unbind();
		 $('html').removeClass('pd_active scroll-prevent');
		 $('.header_out_wrap').removeClass('s_active');
	 }
 
 // pulldownメニュー
 $(window).on('load resize', function(){
		 "use strict";
	 $('#header_nav').hover(
		 function() {
			 $('html').addClass('pd_open scroll-prevent');
		 }, function() {
			 $('html').removeClass('pd_open scroll-prevent');
		 }
	 );
 });
 $(window).on('ready', function(){
		 "use strict";
	 $('#header_nav').hover(
		 function() {
			 $('html').addClass('pd_open scroll-prevent');
		 }, function() {
			 $('html').removeClass('pd_open scroll-prevent');
		 }
	 );
 });
 
 // ------------------- eccube.js -------------------
 
 function ec_cube_click() {
 
		 $('#sp_menu_wrap').on('click', function(){
			 $('.pulldown_in').animate({scrollTop: 0}, 0);
				 if($('html').hasClass('pd_active')){
					 $('html').removeClass('pd_active scroll-prevent');
				 }else{
					 $('html').addClass('pd_active scroll-prevent');
				 }
			 });
 
		 $('#header_nav_search_switch').on('click', function(){
				 if($('.header_out_wrap').hasClass('s_active')){
					 $('.header_out_wrap').removeClass('s_active');
				 }else{
					 $('.header_out_wrap').addClass('s_active');
				 }
			 });
 
		 /**
			* Initialize.
			*/
		 // 規格1選択時
		 /*$('select[name=classcategory_id1]')
			.change(function() {
			var $form = $(this).parents('form');
			var product_id = $form.find('input[name=product_id]').val();
			var $sele1 = $(this);
			var $sele2 = $form.find('select[name=classcategory_id2]');
 
			// 規格1のみの場合
			if (!$sele2.length) {
			eccube.checkStock($form, product_id, $sele1.val(), null);
			// 規格2ありの場合
			} else {
			eccube.setClassCategories($form, product_id, $sele1, $sele2);
			}
			});
 
			// 規格2選択時
			$('select[name=classcategory_id2]')
			.change(function() {
			var $form = $(this).parents('form');
			var product_id = $form.find('input[name=product_id]').val();
			var $sele1 = $form.find('select[name=classcategory_id1]');
			var $sele2 = $(this);
			eccube.checkStock($form, product_id, $sele1.val(), $sele2.val());
			});*/
 
		 // ------------------- function.js -------------------
 
		 $('.pagetop').hide();
 
		 $(window).on('scroll', function () {
				 // ページトップフェードイン
				 if ($(this).scrollTop() > 300) {
						 $('.pagetop').fadeIn();
				 } else {
						 $('.pagetop').fadeOut();
				 }
 
				 // PC表示の時のみに適用
				 if (window.innerWidth > 767) {
 
						 if ($('#shopping-form').length) {
 
								 var side = $(".ec-orderRole__summary"),
												 wrap = $("#shopping-form"),
												 min_move = wrap.offset().top,
												 max_move = wrap.height(),
												 margin_bottom = max_move - min_move;
 
								 var scrollTop = $(window).scrollTop();
								 if (scrollTop > min_move && scrollTop < max_move) {
										 var margin_top = scrollTop - min_move;
										 side.css({"margin-top": margin_top});
								 } else if (scrollTop < min_move) {
										 side.css({"margin-top": 0});
								 } else if (scrollTop > max_move) {
										 side.css({"margin-top": margin_bottom});
								 }
 
						 }
				 }
				 return false;
		 });
 
 
		 $('.ec-headerNavSP').on('click', function () {
				 $('.ec-layoutRole').toggleClass('is_active');
				 $('.ec-drawerRole').toggleClass('is_active');
				 $('.ec-drawerRoleClose').toggleClass('is_active');
				 $('body').toggleClass('have_curtain');
		 });
 
		 $('.ec-overlayRole').on('click', function () {
				 $('body').removeClass('have_curtain');
				 $('.ec-layoutRole').removeClass('is_active');
				 $('.ec-drawerRole').removeClass('is_active');
				 $('.ec-drawerRoleClose').removeClass('is_active');
		 });
 
		 $('.ec-drawerRoleClose').on('click', function () {
				 $('body').removeClass('have_curtain');
				 $('.ec-layoutRole').removeClass('is_active');
				 $('.ec-drawerRole').removeClass('is_active');
				 $('.ec-drawerRoleClose').removeClass('is_active');
		 });
 
		 // TODO: カート展開時のアイコン変更処理
		 $('.ec-headerRole__cart').on('click', '.ec-cartNavi', function () {
				 // $('.ec-cartNavi').toggleClass('is-active');
				 $('.ec-cartNaviIsset').toggleClass('is-active');
				 $('.ec-cartNaviNull').toggleClass('is-active')
		 });
 
		 $('.ec-headerRole__cart').on('click', '.ec-cartNavi--cancel', function () {
				 // $('.ec-cartNavi').toggleClass('is-active');
				 $('.ec-cartNaviIsset').toggleClass('is-active');
				 $('.ec-cartNaviNull').toggleClass('is-active')
		 });
 
		 $('.ec-orderMail__link').on('click', function () {
				 $(this).siblings('.ec-orderMail__body').slideToggle();
		 });
 
		 $('.ec-orderMail__close').on('click', function () {
				 $(this).parent().slideToggle();
		 });
 
		 $('.is_inDrawer').each(function () {
				 var html = $(this).html();
				 $(html).appendTo('.ec-drawerRole');
		 });
 
		 $('.ec-blockTopBtn').on('click', function () {
				 $('html,body').animate({'scrollTop': 0}, 500);
		 });
 
		 // スマホのドロワーメニュー内の下層カテゴリ表示
		 // TODO FIXME スマホのカテゴリ表示方法
		 $('.ec-itemNav ul a').click(function () {
				 var child = $(this).siblings();
				 if (child.length > 0) {
						 if (child.is(':visible')) {
								 return true;
						 } else {
								 child.slideToggle();
								 return false;
						 }
				 }
		 });
 
		 // イベント実行時のオーバーレイ処理
		 // classに「load-overlay」が記述されていると画面がオーバーレイされる
		 $('.load-overlay').on({
				 click: function () {
						 loadingOverlay();
				 },
				 change: function () {
						 loadingOverlay();
				 }
		 });
 
		 // submit処理についてはオーバーレイ処理を行う
		 $(document).on('click', 'input[type="submit"], button[type="submit"]', function () {
 
				 // html5 validate対応
				 var valid = true;
				 var form = getAncestorOfTagType(this, 'FORM');
 
				 if (typeof form !== 'undefined' && !form.hasAttribute('novalidate')) {
						 // form validation
						 if (typeof form.checkValidity === 'function') {
								 valid = form.checkValidity();
						 }
				 }
 
				 if (valid) {
						 loadingOverlay();
				 }
		 });
 
		 var createForm = function (action, data) {
				 var $form = $('<form action="' + action + '" method="post"></form>');
				 for (input in data) {
						 if (data.hasOwnProperty(input)) {
								 $form.append('<input name="' + input + '" value="' + data[input] + '">');
						 }
				 }
				 return $form;
		 };
 
		 $('a[token-for-anchor]').click(function (e) {
				 e.preventDefault();
				 var $this = $(this);
				 var data = $this.data();
				 if (data.confirm != false) {
						 if (!confirm(data.message ? data.message : eccube_lang['common.delete_confirm'])) {
								 return false;
						 }
				 }
 
				 // 削除時はオーバーレイ処理を入れる
				 loadingOverlay();
 
				 var $form = createForm($this.attr('href'), {
						 _token: $this.attr('token-for-anchor'),
						 _method: data.method
				 }).hide();
 
				 $('body').append($form); // Firefox requires form to be on the page to allow submission
				 $form.submit();
		 });
 
 
 }
 
 // ------------------- function.js -------------------
 $(window).on('pageshow', function () {
		 loadingOverlay('hide');
 });
 
 /**
	* オーバーレイ処理を行う関数
	*/
 function loadingOverlay(action) {
 
		 if (action == 'hide') {
				 $('.bg-load-overlay').remove();
		 } else {
				 $overlay = $('<div class="bg-load-overlay">');
				 $('body').append($overlay);
		 }
 }
 
 /**
	*  要素FORMチェック
	*/
 function getAncestorOfTagType(elem, type) {
 
		 while (elem.parentNode && elem.tagName !== type) {
				 elem = elem.parentNode;
		 }
 
		 return (type === elem.tagName) ? elem : undefined;
 }
 
 // anchorをクリックした時にformを裏で作って指定のメソッドでリクエストを飛ばす
 // Twigには以下のように埋め込む
 // <a href="PATH" {{ csrf_token_for_anchor() }} data-method="(put/delete/postのうちいずれか)" data-confirm="xxxx" data-message="xxxx">
 //
 // オプション要素
 // data-confirm : falseを定義すると確認ダイアログを出さない。デフォルトはダイアログを出す
 // data-message : 確認ダイアログを出す際のメッセージをデフォルトから変更する
 //
 
 
 // swiper_lookbook
 var swiper_lb;
 $(window).on('load', function() {
		 swiper_lb = new Swiper('.swiper_lb', {
		 effect: 'slide',
		 slidesPerView: 1,
		 speed: 600,
		 loop: true,
		 watchOverflow: true,
		 navigation: {
				 nextEl: '.swiper-button-next',
				 prevEl: '.swiper-button-prev',
			 },
	 });
 });
 
 // pulldown swiper
 
 $(window).on('load', function() {
		 var swiper_pd;
	 swiper_pd = new Swiper('.swiper_pd', {
		 effect: 'slide',
		 slidesPerView: 3,
		 slidesPerGroup: 3,
		 speed: 600,
		 loop: true,
		 autoplay: {
				 delay: 6000,
				 disableOnInteraction: false,
		 },
		 watchOverflow: true,
		 navigation: {
				 nextEl: '.swiper-button-next',
				 prevEl: '.swiper-button-prev',
			 },
		 breakpoints: {
				 500: {
						 slidesPerView: 1,
						 slidesPerGroup: 1
				 },
				 900: {
						 slidesPerView: 2,
						 slidesPerGroup: 2
				 }
		 }
	 });
 });
 
 function not_ec_pulldown() {
		 var swiper_pd;
		 swiper_pd = new Swiper('.swiper_pd', {
				 effect: 'slide',
				 slidesPerView: 3,
				 slidesPerGroup: 3,
				 speed: 600,
				 loop: true,
				 autoplay: {
						 delay: 6000,
						 disableOnInteraction: false,
				 },
				 watchOverflow: true,
				 navigation: {
						 nextEl: '.swiper-button-next',
						 prevEl: '.swiper-button-prev',
					 },
				 breakpoints: {
						 500: {
								 slidesPerView: 1,
								 slidesPerGroup: 1
						 },
						 900: {
								 slidesPerView: 2,
								 slidesPerGroup: 2
						 }
				 }
			 });
			 var h = $('#header').height();
			 $('body').css('margin-top', h + 'px');
 }
 
 function page_common_function() {
 
		 /* ---------------------- スライダーのイベント ------------------------*/
 
		 var swiper_top;
		 var kazu;
		 swiper_top = new Swiper('.swiper_top', {
				 effect: 'fade',
				 slidesPerView: 1,
				 speed: 800,
				 loop: true,
				 autoplay: {
						 delay: 5000,
						 disableOnInteraction: false,
				 },
				 watchOverflow: true,
				 pagination: {
						 el: ".swiper-pagination",
						 type: 'bullets',
						 clickable: true,
				 },
				 navigation: {
						 nextEl: '.swiper-button-next',
						 prevEl: '.swiper-button-prev',
					 },
				 on: {
						 // activeIndexChange: function () {
						 //     $('.swiper-slide-active').find('.top_slide_txt').addClass('txtOpen');
						 //     console.log($('.swiper-slide-active').find('top_slide_txt'));
						 //     // $('.top_slide_txt').addClass('txtOpen');
						 // },
			 slideChangeTransitionEnd: function () {
								 $('.swiper-slide-active').find('.top_slide_txt').addClass('txtOpen');
						 },
						 slideChangeTransitionStart: function() {
								 if(swiper_top !== undefined){
										 swiper_top.$el.find('.top_slide_txt').removeClass('txtOpen');
								 }
						 }
					 },
		 });
 
		 setTimeout(function(){
				 setTimeout(function(){
				 $('.swiper_top').find('.swiper-slide[data-swiper-slide-index="0"]').addClass('animation').addClass('resize');
				 $('.swiper_top').find('.swiper-pagination-bullet.swiper-pagination-bullet-active').addClass('long').addClass('animation').addClass('resize');
				 },200);
		 },10)
 
		 swiper_top.on('slideChangeTransitionStart', function () {
				 $('.swiper_top').find('.swiper-pagination-bullet').removeClass('long').removeClass('animation').removeClass('resize');
				 $('.swiper_top').find('.swiper-pagination-bullet.swiper-pagination-bullet-active').addClass('long').addClass('animation');
				 $('.swiper_top').find('.swiper-slide-active').each(function(){
				 kazu = Number($(this).attr('data-swiper-slide-index'));
				 $('.swiper-slide[data-swiper-slide-index="'+kazu+'"]').addClass('animation');
				 // $('.box').addClass('boxOpen');
 
				 })
		 });
 
		 swiper_top.on('slideChangeTransitionEnd', function () {
				 $('.swiper_top').find('.swiper-slide').each(function(){
				 var self = $(this);
				 var number = Number($(this).attr('data-swiper-slide-index'));
				 if(kazu !== number){
						 self.removeClass('animation').removeClass('resize');
				 }
				 });
				 slide_click();
		 });
 
		 var timer = false;
		 $(window).on('resize',function() {
				 if (timer !== false) {
				 $('.swiper_top').find('.swiper-slide').removeClass('animation').removeClass('resize');
				 $('.swiper_top').find('.swiper-pagination-bullet').removeClass('long').removeClass('animation').removeClass('resize');
				 clearTimeout(timer);
				 }
				 timer = setTimeout(function() {
 
						 $('.swiper_top').find('.swiper-pagination-bullet.swiper-pagination-bullet-active').addClass('animation');
						 $('.swiper_top').find('.swiper-pagination-bullet.swiper-pagination-bullet-active').addClass('resize');
						 $('.swiper_top').find('.swiper-slide-active').each(function(){
						 kazu = Number($(this).attr('data-swiper-slide-index'));
						 $('.swiper-slide[data-swiper-slide-index="'+kazu+'"]').addClass('animation');
						 $('.swiper-slide[data-swiper-slide-index="'+kazu+'"]').addClass('resize');
						 })
 
				 }, 200);
		 });
 
		 function slide_click(){
				 $('.swiper_top .swiper-wrapper').click(function(){
				 $('.swiper_top .swiper-wrapper').unbind();
				 swiper_top.slideNext();
				 slide_click();
				 })
		 }
		 slide_click();
 
 
 
		 if ($('.swiper-container_wrap.type_shoplist').length > 0) {
				 $('.swiper-container_wrap.type_shoplist').each(function () {
						 if ($(this).find('.swiper-slide').length > 1) {
								 if ($(this).attr('id') === undefined) {
										 var id = 'slide_type_shoplist-' + $('.swiper-container_wrap.type_shoplist').index(this);
 
										 $(this).attr('id', id);
 
										 var slider = new Swiper('#' + id + ' .swiper-container', {
												 grabCursor: true,
												 autoplay: {
														 delay: 4000,
														 disableOnInteraction: false,
												 },
												 speed: 800,
												 loop: true,
												 effect: "fade",
												 spaceBetween: 0
										 });
 
										 slider.autoplay.stop();
 
										 setTimeout(function () {
												 $(window).on('resize', function () {
														 slider.autoplay.start();
												 })
										 }, 2000)
 
										 setTimeout(function () {
												 slider.autoplay.start();
										 }, 2000 + $('.swiper-container_wrap.type_shoplist').index(this) * 2000)
 
										 $(window).on('unload', function () {
												 slider.autoplay.stop();
										 })
 
								 }
						 } else {
								 $(this).addClass('slide_no');
						 }
				 });
		 }
 
		 if ($('.swiper-container_wrap.type_shop').length > 0) {
				 $('.swiper-container_wrap.type_shop').each(function () {
						 // if ($(this).find('.swiper-slide').length > 1) {
								 if ($(this).attr('id') === undefined) {
										 var id = 'slide_type_shop-' + $('.swiper-container_wrap.type_shop').index(this);
 
										 $(this).attr('id', id);
 
										 var slider = new Swiper('#' + id + ' .swiper-container', {
												 grabCursor: true,
												 navigation: {
														 nextEl: '#' + id + ' .swiper-button-next',
														 prevEl: '#' + id + ' .swiper-button-prev',
												 },
												 pagination: {
														 el: '#' + id + ' .swiper-pagination',
														 clickable: true,
												 },
												 autoplay: {
														 delay: 5000,
														 disableOnInteraction: false,
												 },
												 speed: 800,
												 loop: true,
												 direction: "horizontal",
												 effect: "slide",
												 spaceBetween: 0
										 });
 
										 slider.autoplay.stop();
 
										 setTimeout(function () {
												 $(window).on('resize', function () {
														 slider.autoplay.start();
												 })
										 }, 2000)
 
										 setTimeout(function () {
												 slider.autoplay.start();
										 }, 2000 + $('.swiper-container_wrap.type_shop').index(this) * 2000)
 
										 $(window).on('unload', function () {
												 slider.autoplay.stop();
										 })
 
								 }
						 // } else {
						 //     $(this).addClass('slide_no');
						 //     $(this).find('.swiper-pagination_wrap').remove();
						 // }
				 });
		 }
 
		 if ($('.swiper-container_wrap.type_product').length > 0) {
				 $('.swiper-container_wrap.type_product').each(function () {
						 if ($(this).find('.swiper-slide').length > 1) {
								 if ($(this).attr('id') === undefined) {
										 var id = 'slide_type_product-' + $('.swiper-container_wrap.type_product').index(this);
 
										 $(this).attr('id', id);
 
										 var slider = new Swiper('#' + id + ' .swiper-container', {
												 grabCursor: true,
												 navigation: {
														 nextEl: '#' + id + ' .swiper-button-next',
														 prevEl: '#' + id + ' .swiper-button-prev',
												 },
												 pagination: {
														 el: '#' + id + ' .product_thumb_list',
														 clickable: true,
														 renderBullet: function (index, className) {
 
																 return '<li class="product_thumb ' + className + '"><div class="product_thumb_switch imghover"><figure class="img_cover delay_load" data-src=""></figure></div></li>';
														 }
												 },
												 autoplay: {
														 delay: 5000,
														 disableOnInteraction: false,
												 },
												 speed: 800,
												 loop: true,
												 direction: "horizontal",
												 effect: "slide",
												 spaceBetween: 0
										 });
 
										 $('#' + id + ' .product_thumb_switch figure').each(function () {
												 var kazu = $('#' + id + ' .product_thumb_switch figure').index(this) + 1;
												 var src = $('#' + id + ' .swiper-slide:eq(' + kazu + ')').find('.img_cover').attr('data-src');
												 $(this).attr('data-src', src)
										 })
										 slider.on('slideChangeTransitionStart', function () {
												 slider.autoplay.stop();
										 });
										 slider.on('slideChangeTransitionEnd', function () {
												 slider.autoplay.start();
										 });
 
										 slider.autoplay.stop();
 
										 setTimeout(function () {
												 slider.autoplay.start();
												 $(window).on('resize', function () {
														 slider.autoplay.start();
												 })
										 }, 2000)
 
										 setTimeout(function () {
												 slider.autoplay.start();
										 }, 2000 + $('.swiper-container_wrap.type_product').index(this) * 2000)
 
										 $(window).on('unload', function () {
												 slider.autoplay.stop();
										 })
 
								 }
						 } else {
								 $(this).addClass('slide_no');
								 $(this).find('.swiper-pagination_wrap').remove();
						 }
				 });
		 }
 
		 if ($('.swiper-container_wrap.type_news').length > 0) {
				 $('.swiper-container_wrap.type_news').each(function () {
						 if ($(this).find('.swiper-slide').length > 1) {
								 if ($(this).attr('id') === undefined) {
										 var id = 'slide_type_news-' + $('.swiper-container_wrap.type_news').index(this);
 
										 $(this).attr('id', id);
 
										 var speed = 800;
										 var speed_css = speed * 0.001;
 
										 var slider = new Swiper('#' + id + ' .swiper-container', {
												 grabCursor: false,
												 autoplay: {
														 delay: 2500,
														 disableOnInteraction: false,
												 },
												 speed: speed,
												 loop: true,
												 direction: "vertical",
												 autoHeight: true,
												 effect: "slide",
												 spaceBetween: 0,
												 allowTouchMove: false,
										 });
 
										 slider.on('slideChangeTransitionStart', function () {
												 slider.autoplay.stop();
										 });
										 slider.on('slideChangeTransitionEnd', function () {
												 slider.autoplay.start();
										 });
 
										 slider.autoplay.stop();
 
										 setTimeout(function () {
												 $(window).on('resize', function () {
														 slider.autoplay.start();
												 })
										 }, 2000)
 
										 setTimeout(function () {
												 slider.autoplay.start();
										 }, 2000 + $('.swiper-container_wrap.type_news').index(this) * 2000)
 
										 $(window).on('unload', function () {
												 slider.autoplay.stop();
										 })
 
								 }
						 } else {
								 $(this).addClass('slide_no');
								 $(this).find('.swiper-pagination_wrap').remove();
						 }
 
 
 
				 });
		 }
 
		 if ($('.swiper-container_wrap.type01').length > 0) {
				 $('.swiper-container_wrap.type01').each(function () {
 
						 if ($(this).attr('id') === undefined) {
								 var id = 'slide_type01-' + $('.swiper-container_wrap.type01').index(this);
 
								 var pc_kazu = Number($(this).attr('data-pc'));
								 var pad_kazu = Number($(this).attr('data-pad'));
								 var sp_kazu = Number($(this).attr('data-sp'));
								 var slidekazu = $(this).find('.swiper-slide').length;
 
								 var loop = $(this).attr('data-loop');
 
								 $(this).attr('id', id);
 
 
 
								 var slider = new Swiper('#' + id + ' .swiper-container', {
										 navigation: {
												 nextEl: '#' + id + ' .swiper-button-next',
												 prevEl: '#' + id + ' .swiper-button-prev',
										 },
										 pagination: {
												 el: '#' + id + ' .swiper-pagination',
												 clickable: true,
										 },
										 autoplay: {
												 delay: 5000,
												 disableOnInteraction: false,
										 },
										 speed: 500,
										 centeredSlides: false,
										 direction: "horizontal",
										 effect: "slide",
										 // spaceBetween: 40,
										 /*loopAdditionalSlides: 0,
											loopedSlides: 0,*/
										 slidesPerView: pc_kazu,
										 slidesPerGroup: pc_kazu,
										 loop: (loop === undefined || loop !== 'false') ? true : false,
										 //loop: false,
										 grabCursor: (slidekazu > pc_kazu) ? true : false,
										 allowTouchMove: (slidekazu > pc_kazu) ? true : false,
										 preventClicks: (slidekazu > pc_kazu) ? true : false,
										 breakpoints: {
												 951: {
														 //loopFillGroupWithBlank: true,
														 slidesPerView: pc_kazu,
														 slidesPerGroup: pc_kazu,
														 // spaceBetween: 40,
														 grabCursor: (slidekazu > pc_kazu) ? true : false,
														 allowTouchMove: (slidekazu > pc_kazu) ? true : false,
														 preventClicks: (slidekazu > pc_kazu) ? true : false,
												 },
												 950: {
														 //loopFillGroupWithBlank: true,
														 slidesPerView: pad_kazu,
														 slidesPerGroup: pad_kazu,
														 // spaceBetween: 30,
														 grabCursor: (slidekazu > pad_kazu) ? true : false,
														 allowTouchMove: (slidekazu > pad_kazu) ? true : false,
														 preventClicks: (slidekazu > pc_kazu) ? true : false,
												 },
												 768: {
														 //loopFillGroupWithBlank: false,
														 slidesPerView: pad_kazu,
														 slidesPerGroup: pad_kazu,
														 // spaceBetween: 20,
														 grabCursor: (slidekazu > pad_kazu) ? true : false,
														 allowTouchMove: (slidekazu > pad_kazu) ? true : false,
														 preventClicks: (slidekazu > pc_kazu) ? true : false,
												 },
												 700: {
														 //loopFillGroupWithBlank: false,
														 slidesPerView: sp_kazu,
														 slidesPerGroup: sp_kazu,
														 // spaceBetween: 20,
														 grabCursor: (slidekazu > sp_kazu) ? true : false,
														 allowTouchMove: (slidekazu > sp_kazu) ? true : false,
														 preventClicks: (slidekazu > pc_kazu) ? true : false,
												 }
										 }
								 });
 
								 slider.autoplay.stop();
 
								 var remove_number = slidekazu - 1;
 
								 setTimeout(function () {
										 $('#' + id + '').each(function () {
												 if ($(this).find('.swiper-pagination-bullet').length < 2) {
														 $(this).addClass('arrow_no');
														 $('#' + id + '').find('.swiper-slide:gt(' + remove_number + ')').css('display', 'none');
														 $('#' + id + '').find('.swiper-slide:lt(' + slidekazu + ')').css('display', '');
														 //$('#'+id+'').find('.swiper-slide:lt('+slide_kazu+')').css('display','block');
														 slider.slideTo(0);
												 } else {
														 $(this).removeClass('arrow_no');
														 $('#' + id + '').find('.swiper-slide').css('display', '');
												 }
										 })
								 }, 100)
 
								 function slide_event(){
									 $('#' + id + '').each(function () {
											 if ($(this).find('.swiper-pagination-bullet').length < 2) {
													 $(this).addClass('arrow_no');
													 $('#' + id + '').find('.swiper-slide:gt(' + remove_number + ')').css('display', 'none');
													 $('#' + id + '').find('.swiper-slide:lt(' + slidekazu + ')').css('display', '');
													 slider.autoplay.stop();
											 } else {
													 $(this).removeClass('arrow_no');
													 $('#' + id + '').find('.swiper-slide').css('display', '');
													 slider.autoplay.start();
											 }
									 })
								 }
 
								 setTimeout(function () {
									 $(window).on('resize', function () {
										 slide_event();
									 })
									 // リサイズ後
									 var timer = false;
									 $(window).on('resize', function () {
											 if (timer !== false) {
													 clearTimeout(timer);
											 }
											 timer = setTimeout(function () {
												 slide_event();
											 }, 200);
									 })
								 }, 2000)
 
 
								 setTimeout(function () {
									slide_event();
								 }, 2000 + $('.swiper-container_wrap.type01').index(this) * 2000)
 
								 $(window).on('unload', function () {
									 slider.autoplay.stop();
								 })
 
						 }
 
 
				 });
 
 
		 }
 
 
 
 }
 
 // アニメーションイベント
 
 function anime_action(self_event) {
		 if (!$('html').hasClass('loading')) {
				 self_event.each(function () {
						 var kazu = $('.move_anime').index(this);
						 var aa = kazu - 1
						 var self = $(this);
						 if (!self.hasClass('active')) {
								 if (kazu == 0 || $('.move_anime:eq(' + aa + ')').hasClass('active')) {
 
										 self.addClass('active');
										 var duration = Number(self.css('transition-duration').split(',')[0].replace('s', '')) * 1000;
										 var delay = Number(self.css('transition-delay').split(',')[0].replace('s', '')) * 1000;
 
										 var a_number = duration + delay;
										 setTimeout(function () {
												 //self.removeClass('move_anime');
												 self.removeClass(function (index, className) {
														 return (className.match(/\bdelay\S+/g) || []).join(' ');
												 });
												 self.removeClass(function (index, className) {
														 return (className.match(/\bspeed\S+/g) || []).join(' ');
												 });
												 self.removeClass(function (index, className) {
														 return (className.match(/\banime\S+/g) || []).join(' ');
												 });
												 self.addClass('end');
										 }, a_number);
								 }
						 }
				 })
		 }
 }
 
 // スクロールアクション
 
 function scroll_action() {
 
		 if ($('.move_anime').length > 0) {
 
				 $('.move_anime').each(function () {
						 if ($(this).offset().top + $(window).height() * 0.1 <= $(window).scrollTop() + $(window).height() && !$(this).hasClass('active')) {
								 if ((!$(this).parents('.pc_move_anime_group').length > 0 && $(window).outerWidth() > 950) || (!$(this).parents('.pad_move_anime_group').length > 0 && $(window).outerWidth() <= 950 && $(window).outerWidth() > 700) || (!$(this).parents('.sp_move_anime_group').length && $(window).outerWidth() <= 700)) {
										 var self_event = $(this);
										 anime_action(self_event);
								 }
						 }
				 });
				 $('.pc_move_anime_group').each(function () {
						 if ($(this).offset().top + $(window).height() * 0.1 <= $(window).scrollTop() + $(window).height() && $(window).outerWidth() > 950) {
								 var self_event = $(this).find('.move_anime');
								 anime_action(self_event);
						 }
				 });
				 $('.pad_move_anime_group').each(function () {
						 if ($(this).offset().top + $(window).height() * 0.1 <= $(window).scrollTop() + $(window).height() && $(window).outerWidth() <= 950 && $(window).outerWidth() > 700) {
								 var self_event = $(this).find('.move_anime');
								 anime_action(self_event);
						 }
				 });
				 $('.sp_move_anime_group').each(function () {
						 if ($(this).offset().top + $(window).height() * 0.1 <= $(window).scrollTop() + $(window).height() && $(window).outerWidth() <= 700) {
								 var self_event = $(this).find('.move_anime');
								 anime_action(self_event);
						 }
				 });
 
				 if ($('.video_wrap').length > 0) {
						 $('.video_wrap').each(function () {
								 if ($(this).offset().top + $(window).height() * 0.1 <= $(window).scrollTop() + $(window).height() && !$(this).hasClass('active')) {
										 if ((!$(this).parents('.pc_video_group').length > 0 && $(window).width() > 950) || (!$(this).parents('.pad_video_group').length > 0 && $(window).width() <= 950 && $(window).width() > 700) || (!$(this).parents('.sp_video_group').length && $(window).width() <= 700)) {
												 var self_event = $(this);
												 movie_auto(self_event);
										 }
								 }
						 })
						 $('.pc_video_group').each(function () {
								 if ($(this).offset().top + $(window).height() * 0.1 <= $(window).scrollTop() + $(window).height() && $(window).width() > 950) {
										 var self_event = $(this).find('.video_wrap');
										 movie_auto(self_event);
								 }
						 });
						 $('.pad_video_group').each(function () {
								 if ($(this).offset().top + $(window).height() * 0.1 <= $(window).scrollTop() + $(window).height() && $(window).width() <= 950 && $(window).width() > 700) {
										 var self_event = $(this).find('.video_wrap');
										 movie_auto(self_event);
								 }
						 });
						 $('.sp_video_group').each(function () {
								 if ($(this).offset().top + $(window).height() * 0.1 <= $(window).scrollTop() + $(window).height() && $(window).width() <= 700) {
										 var self_event = $(this).find('.video_wrap');
										 movie_auto(self_event);
								 }
						 });
				 }
 
		 }
 
		 if ($('#blog_sub_nav').length > 0) {
				 var sh = $(window).scrollTop() - $('#blog_sub_nav').offset().top;
				 var height = -parseInt($('#blog_sub_nav').css('margin-top')) - parseInt($('#blog_sub_nav').css('padding-top'));
				 var nav_h = $('#blog_sub_nav').outerHeight() - $('#blog_sub_nav_in').outerHeight() - height;
				 var h = $('#header').height();
				 if ($('body').width() > 700) {
						 if ($(window).scrollTop() > $('#blog_sub_nav').offset().top && sh < nav_h) {
								 $('#blog_sub_nav_in').css({'top': h + 'px', 'position': 'fixed'});
						 } else if ($(window).scrollTop() < $('#blog_sub_nav').offset().top) {
								 $('#blog_sub_nav_in').css({'top': 0 + 'px', 'position': 'absolute'});
						 } else {
								 $('#blog_sub_nav_in').css({'top': nav_h + height + 'px', 'position': 'absolute'});
						 }
				 } else {
						 $('#blog_sub_nav_in').css({'top': '0px', 'position': 'static'});
				 }
		 }
 
		 if ($('#footer_pageup').length > 0) {
 
				 if ($(window).outerHeight() + $(window).scrollTop() > $('#all_wrap').height() * 0.3) {
						 if ($('#footer_pageup').css('display') === "none") {
								 $('#footer_pageup').stop().fadeIn(400);
						 }
				 } else {
						 if ($('#footer_pageup').css('display') === "block") {
								 $('#footer_pageup').stop().fadeOut(400);
						 }
				 }
 
				 if ($(window).outerHeight() + $(window).scrollTop() > parseInt($('#footer_pageup').css('bottom')) + $('#footer_pageup_block').outerHeight() + $('#footer_content').offset().top) {
						 $('html').addClass('footer_active');
				 } else {
						 $('html').removeClass('footer_active');
				 }
 
		 }
 
		 if($('#product_add_btn').length > 0){
				if($(window).scrollTop() >=  $('#product_add_btn').outerHeight() + $('#product_add_btn').offset().top ){
					$('#sp_product_fix_btn').addClass('active');
				}else{
					$('#sp_product_fix_btn').removeClass('active');
				}
		 }
 
		 //product_scroll();
 
 }
 
 // -------------------------------- 高さセット --------------------------------
 
 
 function height_func() {
		 window_height();
 
		 if ($('.heightline').length > 0) {
				 var array = [];
				 $('.heightline').each(function () {
						 var group = $(this).attr('data-group');
						 var kazu = $('.heightline[data-group="' + group + '"]').length;
						 var number = $('.heightline[data-group="' + group + '"]').index(this);
						 if (number + 1 == kazu) {
								 array.push('heightline[data-group="' + group + '"]');
						 }
				 });
				 for (i = 0; i < array.length; i++) {
						 $('.' + array[i] + '').heightLine();
				 }
		 }
 
 
		 $('.pulldown_sp #pulldown').each(function(){
			 var hh = Math.ceil( $(window).outerHeight() - $('#header').outerHeight() );
			 $(this).css({
				 'height': hh+'px',
			 })
		 })
 
 }
 
 function window_height() {
		 if ($('.window_height').length > 0) {
				 $('.window_height').each(function () {
						 $(this).css('height', $(window).outerHeight() + 'px');
				 })
		 }
 }
 // -------------------------------- スクロールトップ --------------------------------
 
 function scrolltop_action() {
		 var string = GetQueryString();
		 if (location.hash === "") {
				 $('body,html').animate({scrollTop: 0}, 0);
		 } else {
				 if ($(location.hash).length > 0) {
						 delay_load();
						 var t_obj = $(location.hash);
						 var number = 'translateY';
						 var y = transform2d_value(t_obj, number);
 
						 $(location.hash).each(function () {
								 if ($(this).parents('.move_anime,.t_obj').length > 0) {
										 $(this).parents('.move_anime,.t_obj').each(function () {
												 var t_obj = $(this);
												 var number = 'translateY';
												 y = y + transform2d_value(t_obj, number);
										 })
								 }
						 })
 
						 var hh = t_obj.offset().top - y;
 
						 $('body,html').animate({scrollTop: hh}, 0);
				 }
		 }
 }
 
 
 // -------------------------------- 動画セット --------------------------------
 
 function movie_set() {
		 if ($('.video_wrap').length > 0) {
				 $('.video_wrap').each(function () {
						 var kazu = $('.video_wrap').index(this);
						 if ($(this).find('video').attr('id') === undefined) {
								 $(this).find('video').attr('id', 'video' + kazu);
						 }
				 });
		 }
 }
 
 function movie_auto(self_event) {
		 self_event.each(function () {
				 if ($(this).attr('data-auto') !== undefined && $(this).attr('data-auto') === 'true') {
						 var kazu = $('.video_wrap').index(this);
						 var aa = kazu - 1
						 var self = $(this);
						 if (!self.hasClass('active')) {
								 if (kazu == 0 || $('.video_wrap:eq(' + aa + ')').hasClass('active')) {
										 var id = self.find('video').attr('id');
										 var video_play = document.getElementById(id);
										 if (video_play.paused) {
												 self.addClass('active');
												 video_play.play();
										 }
										 ;
								 }
						 }
				 }
		 })
 }
 
 function movie_resize() {
		 if ($('.video_wrap').length > 0) {
 
				 $('.video_wrap').each(function () {
 
						 if ($(this).attr('data-resize') === 'true' && $(this).attr('data-width') !== undefined && $(this).attr('data-height') !== undefined) {
								 var aa = $(this).outerHeight();
								 var img_w_p = $(this).attr('data-width') / $(this).attr('data-height');
								 var bb = aa * img_w_p;
								 var bm = aa * img_w_p - $(this).outerWidth();
								 var bm2 = -bm / 2
								 var img_w_h = $(this).attr('data-height') / $(this).attr('data-width');
								 var cc = $(this).outerWidth() * img_w_h;
								 var cm = aa - cc;
								 var cm2 = cm / 2;
 
								 if (bb <= $(this).outerWidth()) {
										 $(this).find('video').css({
												 'margin-left': 0 + 'px',
												 'margin-top': cm2 + 'px',
												 'height': cc + 'px',
												 'width': $(this).outerWidth() + 'px'
										 });
								 } else if (bb > $(this).outerWidth()) {
										 $(this).find('video').css({
												 'margin-left': bm2 + 'px',
												 'margin-top': 0 + 'px',
												 'height': aa + 'px',
												 'width': bb + 'px'
										 });
								 }
								 ;
						 }
				 })
		 }
 }
 // -------------------------------- 画像等 --------------------------------
 
 function delay_load() {
		 if ($('.img_cover.delay_load').length > 0) {
				 $('.img_cover.delay_load').each(function () {
						 if (!$(this).hasClass('load_end')) {
								 /*var src = $(this).attr('data-src');
									$(this).css('background-image','url("'+src+'")')*/
								 var self = $(this);
								 var src = self.attr('data-src');
								 self.append('<img src="' + src + '" alt="" class="load_img">');
								 self.find('img').each(function () {
										 $(this).attr('src', src);
										 $(this).on('load', function () {
												 self.addClass('load_img');
												 self.addClass('load_end');
												 self.css('background-image', 'url("' + src + '")');
												 $(this).remove();
										 })
										 $(this).on('error', function () {
												 self.addClass('img_none');
												 self.addClass('load_end');
												 $(this).remove();
										 });
								 })
						 }
 
				 })
		 }
 
		 if ($('.delay_iframe').length > 0) {
				 $('.delay_iframe').each(function () {
						 var src = $(this).attr('data-src');
						 var allow = $(this).attr('data-allow');
						 var width = 'width="' + $(this).attr('data-width') + '"';
						 var height = 'height="' + $(this).attr('data-height') + '"';
						 if ($(this).attr('data-allow') === undefined) {
								 allow = '';
						 }
						 if ($(this).attr('data-width') === undefined) {
								 width = '';
						 }
						 if ($(this).attr('data-height') === undefined) {
								 height = '';
						 }
						 $(this).append('<iframe class="delay_iframe_obj" src="' + src + '" ' + allow + ' ' + width + ' ' + height + '" frameborder="0" allowfullscreen></iframe>');
				 })
				 $('.delay_iframe_obj').each(function () {
						 if (!$(this).closest('.delay_iframe').hasClass('load_end')) {
								 var src = $(this).attr('src');
								 $(this).attr('src', src);
								 $(this).on('load', function () {
										 $(this).closest('.delay_iframe').addClass('load_iframe');
										 $(this).closest('.delay_iframe').addClass('load_end');
								 })
								 $(this).on('error', function () {
										 $(this).closest('.delay_iframe').addClass('iframe_none');
										 $(this).closest('.delay_iframe').addClass('load_end');
								 })
						 }
				 })
		 }
 
		 if ($('.delay_video').length > 0) {
				 $('.delay_video').each(function () {
						 var src = $(this).attr('data-src');
						 var status = $(this).attr('data-status');
						 var width = 'width="' + $(this).attr('data-width') + '"';
						 var height = 'height="' + $(this).attr('data-height') + '"';
						 if ($(this).attr('data-width') === undefined) {
								 width = '';
						 }
						 if ($(this).attr('data-height') === undefined) {
								 height = '';
						 }
						 $(this).after('<video ' + status + ' ' + width + ' ' + height + '"><source src="' + src + '"></video>');
						 $(this).remove();
				 })
		 }
         if ($('.delay_img').length > 0) {
            $('.delay_img').each(function () {
                var src = $(this).attr('data-src');
                var alt = $(this).attr('data-alt');
                var s_class = $(this).attr('data-class');
                var s_id = $(this).attr('data-id');
                var style = 'style="' + $(this).attr('data-style') + '"';
                var width = 'width="' + $(this).attr('data-width') + '"';
                var height = 'height="' + $(this).attr('data-height') + '"';
                if ($(this).attr('data-width') === undefined) {
                    width = '';
                }
                if ($(this).attr('data-height') === undefined) {
                    height = '';
                }
                if ($(this).attr('data-class') === undefined) {
                    s_class = '';
                }
                if ($(this).attr('data-id') === undefined) {
                    s_id = '';
                }
                if ($(this).attr('data-style') === undefined) {
                    style = '';
                }
                $(this).after('<img id="'+ s_id +'" class="delay_img_obj ' + s_class + '" src="' + src + '" ' + style + ' alt="' + alt + '" ' + width + ' ' + height + ' />');
                $(this).remove();
            })
            $('.delay_img_obj').each(function () {
                if (!$(this).hasClass('load_active')) {
                    var src = $(this).attr('src');
                    $(this).attr('src', src);
                    $(this).on('load', function () {
                        $(this).addClass('load_active');
                    })
                    $(this).on('error', function () {
                        $(this).remove();
                    })
                }
            })
        }



 }
 
 // -------------------------------- 各種セット --------------------------------
 
 function page_src_set() {
		 window_height();
		 page_common_function();
		 delay_load();
		 movie_set();
 }
 
 function page_start() {
		//  query_link();
 
		 window_height();
 
		 scrolltop_action();
		//  product_load_remove();
 
		 if ($('#product_list_nav').length > 0) {
				 $('#product_list_nav a').each(function () {
						 var text = $(this).text();
						 if ($(this).text() === '無し') {
								 $(this).closest('li').remove();
						 }
				 })
		 }
 }
 
 // スクロール後、リサイズ後
 
 function resize_action() {
		 height_func();
		 movie_resize();
 }
 
 $(function () {
		 if ($('#cart_head').length > 0 || $('#mypage_nav').length > 0 || $('#no_ajax_page').length > 0 || $('#all_wrap[class*="cart_page"]').length > 0 || $('#all_wrap[class*="mypage"]').length > 0 || $('#all_wrap[class*="contact_page"]').length > 0 ) {
				 $('html').removeClass('loading');
				 $('#loading_block_wrap').remove();
		 }
 
		 page_start();
 })
 
 function page_load() {
 
 
 
		 if (!$('#footer_inner_links_pc').hasClass('active')) {
				 $('#footer_inner_links_pc').addClass('active');
				 $('#footer_inner_links_pc li').each(function () {
						 $('#footer_inner_links_sp .footer_link_list').append($(this).clone());
				 })
		 }
 
		 if ($('.sns_list').length > 0) {
				 $('.sns_list').each(function () {
						 $(this).html('');
						 var url = encodeURIComponent(location.href);
						 var img = encodeURIComponent($('[property="og:image"]').attr('content'));
						 var title = encodeURIComponent($('title').text());
						 var script = "javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=500');return false;";
						 $(this).append('<li><a class="link_block imghover no_ajax" href="mailto:?subject=' + title + '&body=' + url + '"><i class="icon icon_product_mail">mail</i></a></li>');
						 $(this).append('<li><a class="link_block imghover no_ajax" target="_blank" href="https://www.facebook.com/patrick.official.jp/"><i class="icon icon_product_facebook">Facebook</i></a></li>');
						 $(this).append('<li><a class="link_block imghover no_ajax" target="_blank" href="http://twitter.com/intent/tweet?url=' + url + '&text=' + title + '&tw_p=tweetbutton" onclick="' + script + '"><i class="icon icon_product_twitter">twitter</i></a></li>');
						 $(this).append('<li><a class="link_block imghover no_ajax" target="_blank" href="https://page.line.me/zce6929y?openQrModal=true"><i class="icon icon_product_line">line</i></a></li>');
						 $(this).append('<li><a class="link_block imghover no_ajax" target="_blank" href="//jp.pinterest.com/pin/create/button/?guid=2uVAZmjL5Zsk-1&amp;url=' + url + '&amp;media=' + img + '&amp;description=' + title + '" data-pin-log="button_pinit" data-pin-config="beside"><i class="icon icon_product_pinterest">pinterest</i></a></li>');
						 $(this).append('<li class="icon_link_switch"><i class="icon icon_product_link imghover">LINK</i><div class="link-container"><input value="' + location.href + '" type="text" readonly></div></li>');
				 });
		 }
 
		 if ($('.page_gmo_mypage_card_edit #form1').length > 0) {
				 $('.page_gmo_mypage_card_edit .ec-pageHeader h1').addClass('title').addClass('type03')
				 $('.page_gmo_mypage_card_edit .ec-pageHeader h1').appendTo($('#form1').find('.ec-cardRole:eq(0)'));
		 }
 
		 if ($('.maypage_nav_list.logout_nav').length > 0) {
				 $('.maypage_nav_list.logout_nav').appendTo('#mypage_nav_list')
		 }
 
		 if($('#product_add_btn').length > 0){
			 $('#footer').addClass('product_add_type')
		 }
 
		 page_src_set();
		 resize_action();
		 scroll_action();
		//  page_common_click();
 
 
 
 }
 function load_common() {
		 if ($('#header').hasClass('html_type')) {
				 var url = $('#header').attr('data-url');
				 $.ajax({
						 type: "GET",
						 url: url,
						 dataType: "html",
						 cache: true,
						 success: function (html) {
								 $('#header').html("");
								 $('#footer').html("");
								 var append_header = $(html).find('#header').html();
								 $(append_header).appendTo('#header');
								 var append_footer = $(html).find('#footer').html();
								 $(append_footer).appendTo('#footer');
								 page_load();
 
								 load_anime();
								 $('#header_nav').hover(
										 function() {
											 $('html').addClass('pd_open scroll-prevent');
										 }, function() {
											 $('html').removeClass('pd_open scroll-prevent');
										 }
									 );
						 }
				 });
 
		 } else {
				 page_load();
				 load_anime();
 
 
		 }
 }
 
 function load_anime() {
		 scrolltop_action();
		 $('#loading_block_wrap .loading_logo').addClass('action01')
		 setTimeout(function () {
				 $('#loading_block_wrap').addClass('active2');
				 setTimeout(function () {
						 $('html').removeClass('loading');
						 $('#loading_block_wrap').removeAttr('class');
						 $('#loading_block_wrap .loading_logo').removeClass('action01');
				 }, 500)
		 }, 1000)
 }
 
 $(window).on('load', function () {
 
		 if (_ua.Mobile || _ua.Tablet) {
				 $('html').addClass('touch');
		 } else {
				 $('html').addClass('normal');
		 }
 
		 // リサイズ後
		 var timer = false;
		 $(window).on('resize', function () {
				 if (timer !== false) {
						 clearTimeout(timer);
				 }
				 timer = setTimeout(function () {
				 }, 200);
		 })
 
		 $(window).on('resize', function () {
				 /*if ($('html').hasClass('pc')) {
						 resize_action();
				 }*/
			 resize_action();
		 });
 
		 $(window).on('orientationchange', function () {
				 resize_action();
		 });
 
		 $(window).on('scroll resize touchstart touchmove touchend', function () {
				 scroll_action();
		 })
 
		 setInterval(function () {
				 scroll_action();
		 }, 100);
 
		 $('#first_load').remove();
 
		 load_common();
 
 });

// swiper関連追記
var swiper_shop_detail;
$(window).on('load', function() {
	swiper_shop_detail = new Swiper('.swiper_shop_detail', {
		effect: 'slide',
		centeredSlides : true,
		slidesPerView: 2,
		speed: 1200,
		loop: true,
		watchOverflow: true,
		autoplay: {
			delay: 3500,
			disableOnInteraction: false,
		},
		pagination: {
			el: ".swiper-pagination",
			type: 'bullets',
			clickable: true,
			},
	});
});

// collection
function sort_category(category) {
  if(!$('.q_content_item').hasClass('hide')) {
    $('.q_content_item').addClass('hide');
  }
  if($('.'+category).hasClass('sort')) {
		$('.q_content_item').removeClass('hide');
    $('.'+category).removeClass('sort'); 
  }else if('.'+category == 'all'){
    $('.q_content_item').remoceClass('hide'); 
  }else{
    $('.q_content_item.sort').removeClass('sort'); 
    $('.'+category).addClass('sort');
  }
}